/* eslint-disable camelcase */
export const toOptions = (arr, defaultId) => {
  const result = arr.map(({ name, id, description, role_type }) => {
    if (role_type === 'SUPER_ADMIN') {
      return {
        value: id,
        key: id,
        label: 'Admin',
        roleType: role_type,
        description,
        isDefault: id === defaultId,
      };
    }

    return {
      value: id,
      key: id,
      label: name,
      roleType: role_type,
      description,
      isDefault: id === defaultId,
    };
  });

  return result;
};

/**
 * When a tab is feature toggled, the feature flag in context is initial set to false.
 * Because the tab index loaded from local storage could be set to one of the feature toggled
 * tabs, the value would be higher than what the Material UI tabs maximum is.  To workaround
 * the issue, this function determines how many tabs are feature toggled and sets the index
 * to an appropriate value.
 *
 * @param {Number} tabIndex The current tab index in local storage
 * @param {Array} flags A list of feature flag booleans
 */
export const getTabIndex = (tabIndex, flags) => {
  const flagsEnabled = flags.filter((flag) => flag).length;

  return tabIndex > flagsEnabled ? 0 : tabIndex;
};

/**
 * Feature toggled tabs rely on the tab index to display the correct panel.
 * When a feature toggle is disabled, the ideal tab index should they all be loaded
 * is offset.  This function resolves the issue should features be disabled.
 *
 * @param {Number} tabIndex The current tab panel index if all flags are enabled
 * @param {Array} flags A list of feature flag booleans
 */
export const getTabPanelIndex = (tabIndex, flags) => {
  const flagsDisabled = flags.filter((flag) => !flag).length;

  return tabIndex - flagsDisabled;
};

/**
 * Parse through the locations to find a matching ID.
 * Return the label of the location object if found.
 *
 * @param {Array} locations List of Location Options
 * @param {Number} id The Location ID
 */
export const getLocationName = (locations, id) => {
  // Find the new location name from the options
  const location = locations.find((ele) => ele.key === id);

  // Check that the location option was found
  return location ? location.label : '';
};
